<template>
  <section class="partner-promo l-page-content">
    <h1 class="section-title section-title--with-sub">
      Что такое Your Loy для Вашего бизнеса?
    </h1>
    <p class="section-subtitle">
      Эффективная программа лояльности превращает случайных посетителей в
      постоянных клиентов и мотивирует их покупать больше Ваших товаров и услуг
    </p>

    <ul class="partner-promo__list">
      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--no-plastic" />
        <div>
          <p class="partner-promo__item-title">Никакого пластика</p>
          <p class="partner-promo__item-text">
            Отсутсвие затрат на изготовление карт
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--analytics" />
        <div>
          <p class="partner-promo__item-title">Аналитическая информация</p>
          <p class="partner-promo__item-text">
            Анализ информации о Ваших покупателях и продажах
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--contact" />
        <div>
          <p class="partner-promo__item-title">Полный контакт</p>
          <p class="partner-promo__item-text">
            Коммуникация с Вашими клиентами через SMS и PUSH
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--clients" />
        <div>
          <p class="partner-promo__item-title">Готовая база клиентов</p>
          <p class="partner-promo__item-text">
            Активная база пользователей Мо.Карты более 70 000 человек
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--bonuses" />
        <div>
          <p class="partner-promo__item-title">Вознаграждения бонусами</p>
          <p class="partner-promo__item-text">
            Начисление дополнительных бонусов лояльным покупателям
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--integration" />
        <div>
          <p class="partner-promo__item-title">Интеграция в ПО</p>
          <p class="partner-promo__item-text">
            Простая система интеграции в Ваше программное обеспечение
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--settings" />
        <div>
          <p class="partner-promo__item-title">Настройка и управление</p>
          <p class="partner-promo__item-text">
            Гибкая настройка правил Вашей системы лояльности
          </p>
        </div>
      </li>

      <li class="partner-promo__list-item">
        <i class="partner-promo__icon partner-promo__icon--profile" />
        <div>
          <p class="partner-promo__item-title">Профиль компании</p>
          <p class="partner-promo__item-text">
            Страница Вашей компании на нашем сайте и в приложении
          </p>
        </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {};
</script>

<style lang="scss">
.partner-promo {
  padding-bottom: 2rem;

  &__list {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-wrap: wrap;
  }

  &__list-item {
    display: flex;
    width: calc(100% / 4);
    padding: 2rem .5rem;
    box-sizing: border-box;

    @include device-until(wide) {
      width: calc(100% / 2);
    }

    @include device-until(tablet) {
      width: 100%;
      flex-direction: column;
      align-items: center;
      padding: 1rem 1rem;
      text-align: center;
    }
  }

  &__item-title {
    font-family: BloggerSans,Helvetica Neue,Helvetica,Roboto,Arial,sans-serif;
    font-size: 1.25rem;
    line-height: 1.5rem;
    color: #4b4b4b;
    margin: 0;
  }

  &__item-text {
    font-size: 1rem;
    line-height: 1.3rem;
    margin: .3rem 0 0;
  }

  &__icon {
    flex-shrink: 0;
    margin-right: 1rem;
    display: inline-block;
    width: 72px;
    height: 72px;

    @include device-until(tablet) {
      margin-right: 0;
      margin-bottom: 1rem;
    }

    &--no-plastic {
      background: url('~@/assets/images/icons/promo-no-plastic.png')
    }
    &--analytics {
      background: url('~@/assets/images/icons/promo-analytics.png')
    }
    &--contact {
      background: url('~@/assets/images/icons/promo-contact.png')
    }
    &--clients {
      background: url('~@/assets/images/icons/promo-clients.png')
    }
    &--bonuses {
      background: url('~@/assets/images/icons/promo-bonuses.png')
    }
    &--integration {
      background: url('~@/assets/images/icons/promo-integration.png')
    }
    &--settings {
      background: url('~@/assets/images/icons/promo-settings.png')
    }
    &--profile {
      background: url('~@/assets/images/icons/promo-profile.png')
    }
  }
}
</style>
